import React from 'react'
import HeaderAndNavbar from '../../components/headerAndNavbar/HeaderAndNavbar'
import Footer from '../../components/footer/Footer'

const Affiliates = () => {
  return (
    <div>
      <HeaderAndNavbar />
      <div className='container mt-5 mb-5 pb-5'>
        <h1 className='mb-4 text-center mt-5'>Want to be a Affiliate ?</h1>
            <p className='mb-5'>By investing an initial amount of time into a campaign, you will see continuous returns on that time as consumers purchase the product over the following days and weeks. You receive money for your work long after you’ve finished it. Even when you’re not in front of your computer, your marketing skills will be earning you a steady flow of income.</p>
            <p className='mb-5'>Contact us for info.</p>
        </div>
        <Footer/>
        </div>
  )
}

export default Affiliates
